import { render } from "./PostActions.vue?vue&type=template&id=2b81b03f&scoped=true"
import script from "./PostActions.vue?vue&type=script&lang=js"
export * from "./PostActions.vue?vue&type=script&lang=js"

import "./PostActions.vue?vue&type=style&index=0&id=2b81b03f&lang=scss&scoped=true"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b81b03f"]])

export default __exports__